import { FormMotivosFiltro } from "@/erp/mantenimiento-operacion/pendiente-actualizar-operacion/page/pendiente-actualizar-operacion/PendienteActualizarOperacion";
import {
  ContratosCorreccionPara,
  EstadoPreventaEnum,
  EstadosContratoChoiceEnum,
  gridSizeMdLg1,
  ModulosEnumChoice,
  gridSizeMdLg6,
  ROUTER_PATHS,
} from "@/shared";
import {
  useFetchContratos,

  useFetchObservacion
} from "@/shared/actions/erp";
import {
  CustomAutocompleteArrString,
  SingleIconButton,
} from "@/shared/components/ui";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import { useTableFilter, useTableServerSideFiltering } from "@/shared/hooks";
import { useTableColumnsPreventa } from "@/shared/hooks/useTableColumnsPreventa";
import { Contrato } from "@/shared/interfaces";
import {
  useFetchMotivosRechazo,
} from "@/shared/actions/erp";

import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Grid } from "@mui/material";

import { ReactNode } from "react";
import { FieldError, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const clientesFibraOReturnUrl = ROUTER_PATHS.clientes.clienteContratoNav;

export default function PreventaActualizacionContratoPage() {
  const navigate = useNavigate();

  const form = useForm<FormMotivosFiltro>({});
  const watchedMotivoCorreccion = form.watch("motivocorreccioncontrato", "");
  const { errors } = form.formState;
   const {
    data: motivosCorreccionContrato,
  } = useFetchMotivosRechazo({
    estado: true,
    modulo: ModulosEnumChoice.CONTRATOS,
    page_size: 256,
    nombre: "VENTAS",
  });

  const {
    isLoading: isLoadingObservacionDatos
  } = useFetchObservacion();

  //HOOK PERSONALIZADO
  const { columnsPreventaContratosNovedades } = useTableColumnsPreventa(
    EstadoPreventaEnum.EN_ESPERA
  );

  const { pagination, setPagination } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const {
    data: contratosPagingRes,
    isLoading: isLoadingContratos,
    isRefetching: isRefetchingContratos,
  } = useFetchContratos({
    enabled: true,
    params: {
      page: pageIndex + 1,
      page_size: pageSize,
      estado_actualizacion: EstadosContratoChoiceEnum.SOLICITUD_CORRECCION,
      correccion_para_exclude: ContratosCorreccionPara.TECNICO,
      estado_contrato_in: `${EstadosContratoChoiceEnum.ACTIVO},${EstadosContratoChoiceEnum.SUSPENDIDO}`,
      observaciones_contrato: watchedMotivoCorreccion,
      ...filterObject,
    },
  });

console.log(contratosPagingRes)

const contratosConNuevasObs = (contratosPagingRes?.data.data || []).map((contrato) => ({
  ...contrato,
  nuevas_observaciones: [], 
}));


  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sx={{ display: "flex" }}>
         <CustomAutocompleteArrString
          size={gridSizeMdLg6}
          label="Motivo Corrección"
          name="motivocorreccioncontrato"
          control={form.control}
          defaultValue={form.getValues().motivocorreccioncontrato || ""}
          options={
            // (observacionesDatos?.data.data
            // .filter((x)=>x.responsable_data?.tipo_responsable ==="VENTAS")
            // .map(x=>x.nombre_observacion) as any )|| []
            motivosCorreccionContrato?.data?.data
              ?.map((item) => item.nombre)
              ?.concat([""])!
          }
          isLoadingData={isLoadingObservacionDatos}
          error={errors.motivocorreccioncontrato as FieldError}
          helperText={errors.motivocorreccioncontrato?.message as ReactNode}
          disableClearable
        /> 
        <SingleIconButton
          size={gridSizeMdLg1}
          startIcon={<FilterAltOffIcon />}
          onClick={() => {
            form.setValue("motivocorreccioncontrato", "");
          }}
        />

        {/* <CustomSearch
            enableSearch={false}
            onChange={onChangeFilter}
            value={globalFilter}
            text="por Identificacion"
            onChangeRangeDate={onChangeRangeDate}
            cleanFilter={cleanFilter}
          /> */} 
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<Contrato>
          // columns={columnsPreventaContratosNovedades}
          columns={columnsPreventaContratosNovedades}
          data={contratosConNuevasObs}
          isLoading={isLoadingContratos}
          isRefetching={isRefetchingContratos}
          enableGlobalFilter={false}
          pagination={pagination}
          onPaging={setPagination}
          rowCount={contratosPagingRes?.data?.count}
          actionsColumnSize={120}
          canDelete={false}
          ///* filters - server side
          enableManualFiltering={true}
          columnFilters={columnFilters}
          onColumnFiltersChange={setColumnFilters}
          enableSorting={false}
          ///* Actions
          positionActionsColumn="first"
          toolTipTitleEditIcon="Acción"
          onEdit={(original) => {
            navigate(
              `${clientesFibraOReturnUrl}/actualizar/${original.id_contrato}`
            );
          }}
          canEdit={true}
          enableEditing={true}
        />
      </Grid>
    </Grid>
  );
}
